// Кнопка действия, которое идёт (задача D7, UX §1 «Движение»): при нажатии — `scale(.97)` (.btn), пока ждём ответа —
// спиннер 14 px поверх подписи. Подпись остаётся на месте (прозрачной), поэтому ширина кнопки не меняется, а имя кнопки
// для чтения с экрана — то же. Пока идёт — `data-pending` и `aria-busy`, повторное нажатие ничего не делает; кнопка не
// гаснет и фокус с неё не уходит (поэтому не `disabled`).
import { Loader2 } from 'lucide-react';
import type * as React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export type PendingButtonProps = React.ComponentProps<typeof Button> & {
  readonly pending: boolean;
  /** Иконка слева от подписи. */
  readonly icon?: React.ReactNode;
};

export function PendingButton({ pending, icon, children, className, onClick, ...props }: PendingButtonProps) {
  return (
    <Button
      {...props}
      aria-busy={pending ? true : undefined}
      data-pending={pending ? '' : undefined}
      className={cn('relative', className)}
      onClick={(event) => {
        if (pending) return;
        onClick?.(event);
      }}
    >
      <span className={cn('inline-flex items-center gap-1.5', pending && 'opacity-0')}>
        {icon}
        {children}
      </span>
      {pending && <Loader2 aria-hidden="true" className="spin pointer-events-none absolute inset-0 m-auto size-3.5" />}
    </Button>
  );
}
